import { ChangeDraftVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import { ExitEditingChoice } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import {
  EditFieldModalHost,
  ExitEditingModal,
} from '@/features/dashboard/bookingChanges/components/editing';
import { UseEditFieldResult } from '@/features/dashboard/bookingChanges/components/editing/useEditField.ts';

interface BookingDetailsModalsProps {
  /** Bez szkicu nie ma czego porzucać, więc modal wyjścia się nie pojawia. */
  draft: ChangeDraftVm | null;
  isExitModalOpen: boolean;
  isDiscarding: boolean;
  onExitChoice: (choice: ExitEditingChoice) => void;
  onExitDismiss: () => void;
  editField: UseEditFieldResult;
}

/**
 * Modale ekranu rezerwacji. Stoją w szkielecie, a nie w zakładkach, bo obsługę
 * wnoszą hooki trybu edycji — przełączenie zakładki nie ma prawa ich zamknąć.
 */
const BookingDetailsModals = ({
  draft,
  isExitModalOpen,
  isDiscarding,
  onExitChoice,
  onExitDismiss,
  editField,
}: BookingDetailsModalsProps) => (
  <>
    {isExitModalOpen && draft && (
      <ExitEditingModal
        draft={draft}
        isDiscarding={isDiscarding}
        onChoice={onExitChoice}
        onDismiss={onExitDismiss}
      />
    )}

    <EditFieldModalHost editField={editField} />
  </>
);

export default BookingDetailsModals;
